import { useSelector } from 'react-redux';

import { isUserGuestOnlySelector } from 'store/auth/selectors';

import ErrorScreen from '../ErrorScreen';

const DeletedOrOnlyGuestErrorScreen = () => {
  const isUserGuestOnly = useSelector(isUserGuestOnlySelector);

  if (isUserGuestOnly) {
    return <ErrorScreen status="guest_only" hideStatusCode />;
  }

  return <ErrorScreen status="deleted" />;
};

export default DeletedOrOnlyGuestErrorScreen;
